"use client";
import dynamic from "next/dynamic";
import { useBlock } from "./context";
import { getModuleEditorAttribute } from "./registry";

const UnavailableAttr = dynamic(() => import("./attributes.editable").then((m) => ({ default: m.UnavailableAttr })), { ssr: false });

/**
 * Theme-supplied integration options for a module attribute. Any object is
 * accepted so module-exported interfaces without an index signature (e.g. the
 * Forms `FormIntegration`) pass as-is; the module validates its own shape.
 */
export type ModuleAttributeIntegration = object;

/** Render an editor attribute registered by an enabled module. */
export function ModuleAttribute(props: { type: string; name: string; integration?: ModuleAttributeIntegration }) {
  const { enabledModules, editing } = useBlock();
  const Attribute = getModuleEditorAttribute(props.type, enabledModules);
  if (Attribute) return <Attribute name={props.name} integration={props.integration as Record<string, unknown> | undefined} />;
  return editing ? <UnavailableAttr type={props.type} /> : null;
}
